// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 25) return "static/js/73a4487db0e25a185175.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"44bfd6bb60783a7b58e7","124":"4341f94991c5f4537980","125":"46431d54d30b941caaf2"}[chunkId] + ".chunk.js";
};